module.exports = __webpack_public_path__ + "img/bg-widget-report.cf6ed195.svg";